export enum ConnectionStatus {
  ACTIVE = 'Active',
  TRANSMITTER_INACTIVE = 'Idle',
  RECEIVER_INACTIVE = 'Idle',
  UNKNOWN = 'Offline'
}
